export const CURRENT_ACCOUNT = 'CURRENT_ACCOUNT';
export const CLEAR_CURRENT_ACCOUNT = 'CLEAR_CURRENT_ACCOUNT';
